/* istanbul ignore file */

import { SVGProps } from 'react';

export function AppSwitcherSvg({
  color = '#15161A',
  width = '14',
  height = '14',
  opacity = '0.85',
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00048 0.333496C1.0801 0.333496 0.333984 1.07961 0.333984 2V4.66666C0.333984 5.58705 1.0801 6.33316 2.00048 6.33316H4.66715C5.58753 6.33316 6.33365 5.58704 6.33365 4.66666V2C6.33365 1.07961 5.58753 0.333496 4.66715 0.333496H2.00048ZM1.66698 2C1.66698 1.81581 1.8163 1.6665 2.00048 1.6665H4.66715C4.85134 1.6665 5.00065 1.81581 5.00065 2V4.66666C5.00065 4.85085 4.85134 5.00016 4.66715 5.00016H2.00048C1.8163 5.00016 1.66698 4.85085 1.66698 4.66666V2ZM9.33382 0.333496C8.41343 0.333496 7.66732 1.07961 7.66732 2V4.66666C7.66732 5.58705 8.41343 6.33316 9.33382 6.33316H12.0005C12.9209 6.33316 13.667 5.58705 13.667 4.66666V2C13.667 1.07961 12.9209 0.333496 12.0005 0.333496H9.33382ZM9.00032 2C9.00032 1.81581 9.14963 1.6665 9.33382 1.6665H12.0005C12.1847 1.6665 12.334 1.81581 12.334 2V4.66666C12.334 4.85085 12.1847 5.00016 12.0005 5.00016H9.33382C9.14963 5.00016 9.00032 4.85085 9.00032 4.66666V2ZM0.333984 9.33333C0.333984 8.41295 1.0801 7.66683 2.00048 7.66683H4.66715C5.58753 7.66683 6.33365 8.41295 6.33365 9.33333V12C6.33365 12.9204 5.58753 13.6665 4.66715 13.6665H2.00048C1.0801 13.6665 0.333984 12.9204 0.333984 12V9.33333ZM2.00048 8.99983C1.8163 8.99983 1.66698 9.14914 1.66698 9.33333V12C1.66698 12.1842 1.8163 12.3335 2.00048 12.3335H4.66715C4.85134 12.3335 5.00065 12.1842 5.00065 12V9.33333C5.00065 9.14914 4.85134 8.99983 4.66715 8.99983H2.00048ZM9.33382 7.66683C8.41343 7.66683 7.66732 8.41295 7.66732 9.33333V12C7.66732 12.9204 8.41343 13.6665 9.33382 13.6665H12.0005C12.9209 13.6665 13.667 12.9204 13.667 12V9.33333C13.667 8.41295 12.9209 7.66683 12.0005 7.66683H9.33382ZM9.00032 9.33333C9.00032 9.14914 9.14963 8.99983 9.33382 8.99983H12.0005C12.1847 8.99983 12.334 9.14914 12.334 9.33333V12C12.334 12.1842 12.1847 12.3335 12.0005 12.3335H9.33382C9.14963 12.3335 9.00032 12.1842 9.00032 12V9.33333Z"
        fill={color}
        fillOpacity={opacity}
      />
    </svg>
  );
}
